import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    ResponsiveContainer,
    Legend,
  } from "recharts";
  import { Card, CardBody, CardHeader } from "reactstrap";
  
  const PieCharts = () => {
    const data = [
      { name: "Door", value: 28.4 },
      { name: "Solar", value: 35.4 },
      { name: "Battery", value: 8.3 },
      { name: "Pressure", value: 27.1 },
    ];
  
    const COLORS = ["#DC3545", "rgb(43, 95, 96)", "#9470CE", "#EFCF20"];
  
    return (
      <Card className="m-0 b-r-0">
        <CardHeader>
          <h5 style={{ fontWeight: "600" }}>Alarms</h5>
        </CardHeader>
        <CardBody >
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={80}
                fill="#8884d8"
                label
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip 
               />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </CardBody>
      </Card>
    );
  };
  
  export default PieCharts;
  